import React, { useEffect, useRef } from 'react';
import { Check, Clock, ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function FleetSelector({ fleets, selectedFleet, getStyle, getRateLimit, onSelect, announcement }) {
  const { t } = useTranslation();
  const railRef = useRef(null);

  useEffect(() => {
    const showSelectedFleet = () => {
      const rail = railRef.current;
      const card = rail?.querySelector('[aria-pressed="true"]');
      if (!card || rail.scrollWidth <= rail.clientWidth) return;
      const left = card.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
      rail.scrollTo({ left: left - (rail.clientWidth - card.clientWidth) / 2, behavior: 'auto' });
    };
    showSelectedFleet();
    window.addEventListener('resize', showSelectedFleet);
    return () => window.removeEventListener('resize', showSelectedFleet);
  }, [selectedFleet?.id]);
  return (
    <section className="fleet-selector" aria-labelledby="fleet-selector-title">
      <div className="fleet-section-heading">
        <div className="fleet-section-title"><h1 id="fleet-selector-title">{t('fleetDesign.chooseFleet')}</h1></div>
        <div className="fleet-section-actions">
          {announcement}
        </div>
      </div>
      <div className="fleet-selector-grid" ref={railRef}>
        {fleets.map(fleet => {
          const style = getStyle(fleet.type);
          const Icon = style.icon;
          const selected = selectedFleet?.id === fleet.id;
          const rateLimit = getRateLimit(fleet.type);
          const limitsKey = fleet.type.startsWith('gpt') ? 'gpt' : fleet.type.startsWith('claude') ? 'claude' : fleet.type;
          return (
            <div key={fleet.id} className={`fleet-service-card ${selected ? 'is-selected' : ''}`}>
            <button type="button" className="fleet-service-select"
              aria-label={fleet.name} aria-pressed={selected} onClick={() => onSelect(fleet)}>
              <div className="fleet-service-top">
                <div className="fleet-service-icon">
                  <img src={style.image} alt="" onError={event => { event.currentTarget.style.display = 'none'; event.currentTarget.nextSibling.style.display = 'flex'; }} />
                  <span style={{ display: 'none' }}><Icon size={24} /></span>
                </div>
                <span className={`fleet-service-check ${selected ? 'is-selected' : ''}`} aria-hidden="true">{selected && <Check size={13} strokeWidth={2.5} />}</span>
              </div>
              <h3>{fleet.name}</h3>
              <p className="fleet-service-description">{t(`fleetDesign.services.${fleet.type}`, fleet.name)}</p>
            </button>
            {rateLimit && (
              <details className="fleet-service-limits">
                <summary><Clock size={12} aria-hidden="true" /><span>{t('fleetDesign.limitsTitle')}</span><ChevronDown size={13} aria-hidden="true" /></summary>
                <div className="fleet-service-limits-content">
                  <p>{t(`fleetDesign.limits.${limitsKey}`, rateLimit)}</p>
                  <p className="fleet-service-limits-note">{t('fleetDesign.limitsNote')}</p>
                </div>
              </details>
            )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
